/**
 * Created by razial on 15.05.2024.
 */

const SimpleInfoView = cc.Node.extend({
    ctor: function (info, unit) {
        this._super();

        this.debugId = "InfoView";

        this.info = info;
        this.unit = unit;

        const background = new cc.Sprite(bundles.merge.frames.simple_info_bg);
        background.setPosition(background.width / 2, background.height / 2);

        this.setContentSize(background.width, background.height);
        this.setAnchorPoint(0.5, 0.5);
        this.addChild(background);

        this.clickHandler = cleverapps.UI.onClick(this, this.onClicked.bind(this), {
            interactiveScale: false
        });

        Map2d.currentMap.getMapView().watchInfoViewHovered(this);

        this.createContent();

        this.selectAdviceTarget(info);

        this.setScale(cleverapps.styles.SimpleInfoView.scale);
        this.baseScale = cleverapps.styles.SimpleInfoView.scale;

        cleverapps.effects.fire("expedition.simpleinfo.show");
    },

    createContent: function () {
        if (this.content) {
            this.content.removeFromParent();
            this.content = undefined;
        }
        
        let content = undefined;
        const info = this.info;
        if (info.buttons && info.buttons.energy) {
            content = new TextWithIcon(`${info.buttons.energy.energy}%%`, {
                font: info.buttons.energy.energy > cleverapps.lives.amount
                    ? cleverapps.styles.FONTS.SIMPLEINFO_WARNING_TEXT
                    : cleverapps.styles.FONTS.SIMPLEINFO_TEXT
            });
        }

        if (info.buttons && info.buttons.explode) {
            content = new cc.Sprite(bundles.merge.frames.icon_explode);
        }

        if (!content) {
            return;
        }

        this.content = content;

        const styles = cleverapps.styles.SimpleInfoView;
        const rect = cc.rectSubPadding(cc.rect(0, 0, this.width, this.height), cc.padding(styles.padding));
        cleverapps.UI.fitToBox(content, {
            width: rect.width,
            height: rect.height
        });
        content.setAlignment(styles.content);
        this.addChild(content);

        this.content.setCascadeOpacityEnabledRecursively(true);
    },

    selectAdviceTarget: function (info) {
        if (info.buttons && info.buttons.energy) {
            this.adviceTarget = "energy";
        }
    },

    onClicked: function () {
        if (this.clicked) {
            return;
        }
        this.clicked = true;

        let action;

        if (this.action) {
            action = this.action;
        } else if (this.info.buttons && this.info.buttons.energy) {
            action = this.info.buttons.energy.action;
        } else if (this.info.buttons && this.info.buttons.explode) {
            action = this.info.buttons.explode.action;
            cleverapps.effects.fire("ui.button.click");
        }

        const proceed = () => {
            if (action && action()) {
                this.animateDelta(this.info);
                InfoView.CloseInfo(Boolean(action), false, 160);
            } else {
                this.clicked = false;
            }
        };

        if (cleverapps.adsLimits.state(AdsLimits.TYPES.INTERSTITIAL) !== AdsLimits.STATE_READY
            || cleverapps.tutorial.isActive()
            || cleverapps.focusManager.isFocused()) {
            proceed();
            return;
        }

        const close = this.createListener(proceed);
        cleverapps.focusManager.display({
            focus: "showInterstitialInfo",
            action: function (f) {
                cleverapps.rewardedAdsManager.showInterstitial({
                    limit: AdsLimits.TYPES.INTERSTITIAL,
                    placement: AdsLimits.TYPES.INTERSTITIAL_INACTIVE
                }, () => {
                    f();
                    close();
                });
            }
        });
    },

    animateDelta: function (info) {
        const movingNode = cleverapps.Scenes.GetMovingNode(this);

        this.content.replaceParentSamePlace(movingNode, {
            keepScale: true
        });

        const styles = cleverapps.styles.SimpleInfoView.backlight;

        const backlight = new cc.Sprite(bundles.merge.frames.simple_info_backlight);
        backlight.setPosition(this.content.width / 2, this.content.height / 2);
        backlight.setLocalZOrder(-1);
        backlight.setOpacity(0);

        this.content.setCascadeOpacityEnabledRecursively(true);

        this.content.runAction(new cc.Sequence(
            new cc.ScaleTo(0.15, this.content.scaleX * 1.05, this.content.scaleY * 0.7),
            new cc.ScaleTo(0.075, this.content.scaleX, this.content.scaleY),
            new cc.ScaleTo(0.075, this.content.scaleX * 0.8, this.content.scaleY * 1.05),
            new cc.ScaleTo(0.225, this.content.scaleX, this.content.scaleY)
        ));

        this.content.runAction(new cc.Sequence(
            new cc.DelayTime(0.15),
            new cc.CallFunc(() => {
                if (info.buttons && info.buttons.energy) {
                    const width = this.content.width * this.content.scaleX;
                    this.content.setString(`-${this.content.getString()}`);
                    this.content.x -= (this.content.width * this.content.scaleX - width) / 2;
                }

                this.content.addChild(backlight);
                backlight.runAction(new cc.Sequence(
                    new cc.FadeTo(0.1, 160),
                    new cc.DelayTime(0.25),
                    new cc.FadeOut(1)
                ));
            }),
            new cc.MoveBy(0.15, 0, styles.deltaY / 3),
            new cc.MoveBy(0.6, 0, styles.deltaY / 3 * 2).easing(cc.easeOut(1.4))
        ));

        this.content.runAction(new cc.Sequence(
            new cc.DelayTime(0.9),
            new cc.FadeOut(0.45),
            new cc.RemoveSelf()
        ));
    },

    setInactive: function () {
        this.setOpacity(180);

        if (this.clickHandler) {
            this.clickHandler.remove();
            delete this.clickHandler;
        }

        this.setCascadeOpacityEnabledRecursively(true);
    },

    setActive: function (action) {
        this.action = action;

        this.clickHandler = cleverapps.UI.onClick(this, this.onClicked.bind(this), {
            interactiveScale: false
        });
        this.createContent();
        this.setLocalZOrder(Map2d.currentMap.getMapView().getAdditionalViewLocalZOrder(this.unit.x, this.unit.y) + 10);

        const baseScale = this.getScale();
        this.runAction(new cc.Spawn(
            new cc.FadeIn(0.3),
            new cc.Sequence(
                new cc.ScaleTo(0.15, 1.1 * baseScale),
                new cc.ScaleTo(0.15, baseScale)
            )
        ));
    }
});

SimpleInfoView.CreateForUnit = function (unit) {
    let info;
    let unitView;
    if (unit instanceof Unit) {
        info = unit.findComponent(Mineable).getActionInfo();
        unitView = unit.onGetView();
    } else {
        const mineableData = Families[unit.code].units[unit.stage].mineable;
        if (mineableData && mineableData.tasks[0].energy) {
            info = {
                buttons: {
                    energy: {
                        energy: mineableData.tasks[0].energy
                    }
                }
            };
        }
        const tile = Map2d.currentMap.getFog(unit.x, unit.y);
        unitView = tile && tile.onGetView() && tile.onGetView().unitNode;
        if (unitView && Array.isArray(unitView)) {
            unitView = unitView[0];
        }
    }

    if (!info || !unitView || (info.buttons && info.buttons.energy && info.buttons.energy.energy === 0)) {
        return undefined;
    }

    const infoView = new SimpleInfoView(info, unit);
    const mapView = Map2d.currentMap.getMapView();

    infoView.setInactive();

    const multiple = unit instanceof Unit && unit.findComponent(Multiple);
    const multipleDy = multiple ? (multiple.unitsVisibility.length - 1 - multiple.indexInCell) * cleverapps.styles.InfoView.multipleDy : 0;

    infoView.setAnchorPoint(0.5, 0);
    infoView.setAlignment(unitView.width / 2, unitView.height + cleverapps.styles.InfoView.dy + multipleDy);
    unitView.addChild(infoView);
    infoView.replaceParentSamePlace(mapView.cloudsAbove);
    infoView.setLocalZOrder(mapView.getAdditionalViewLocalZOrder(unit.x, unit.y));

    return infoView;
};

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    SIMPLEINFO_TEXT: {
        name: "nostroke",
        size: 50,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    SIMPLEINFO_WARNING_TEXT: {
        name: "nostroke",
        size: 50,
        color: cleverapps.styles.COLORS.COLOR_RED
    }
});

cleverapps.styles.SimpleInfoView = {
    scale: 1.7,

    padding: {
        x: 10,
        y: 5
    },

    content: {
        x: { align: "center", dx: 0 },
        y: { align: "center", dy: 7 }
    },

    backlight: {
        x: { align: "center" },
        y: { align: "center" },
        deltaY: 130
    }
};
